import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';
import InputField from 'components/InputField';
import { RfiCreateStep } from 'router/subrouters/DataRoom/models/DataRoomRfi';

import './StepTemplate.styles.scss';

type StepTemplateProps = {
  className?: string;
} & RfiCreateStep;

const StepTemplate: React.FC<StepTemplateProps> = (props) => {
  const { className, isCreatingOrEditingTemplate } = props;

  const classes = classNames('step-template', className);

  const {
    values: { saveAsTemplate },
  } = useFormState();

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{t('makeTemplateDescription')}</p>

      {!isCreatingOrEditingTemplate && (
        <Field
          name="saveAsTemplate"
          component={CheckboxField}
          label={t('saveRequestTemplate')}
          type="checkbox"
        />
      )}

      {(isCreatingOrEditingTemplate || saveAsTemplate) && (
        <Field
          name="saveAsTemplateName"
          component={InputField}
          label={t('templateName')}
        />
      )}
    </div>
  );
};

export default StepTemplate;
